import axios from 'utils/axios';

export async function fetchTwilioAccessToken() {
    try {
        const response = await axios.post('/api/org-id/{orgId}/clinic-id/{clinicId}/twilio/access-token');
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            throw e;
        }
        throw new Error('unknown error');
    }
}

// `clinicId` is passed explicitly because the axios interceptor's {clinicId}
// substitution only fires on /clinic/... paths, and the poll outlives that.
export async function fetchGeneratedCareSessionNote(clinicId, callSid) {
    return axios.get(`/api/org-id/{orgId}/clinic-id/${clinicId}/twilio/outbound-call/${callSid}/generated-note`);
}
